import { AppThunk } from '../../store';
import { normalize, schema } from 'normalizr';
import cartoondrawApi from '../../api/cartoondrawApi';
import {
  setError,
  setLoading,
  setIds,
  setCategories
} from '../../store/cartoondraw/categoriesSlice';
import cartoondrawUrls from "../../configs/cartoondraw/cartoondrawUrls";

const processStrategy = (value: any) => {
  return {
    ...value,
    icon_url: cartoondrawUrls.remoteUrl(value.icon_url),
    image_url: cartoondrawUrls.remoteUrl(value.image_url),
    thumbnail_url: cartoondrawUrls.remoteUrl(value.thumbnail_url),
    url: cartoondrawUrls.categoryPath(value.target_id, value.id)
  };
}

const subcategoryEntity = new schema.Entity(
  'subcategories',
  {},
  {
    processStrategy
  }
);

const categoryEntity = new schema.Entity(
  'categories',
  {
    subcategories: [subcategoryEntity]
  },
  {
    processStrategy
  }
);

export const fetchCategories = (): AppThunk => async dispatch => {
  dispatch(setLoading(true));

  cartoondrawApi.get('/onesky/categories')
    .then(response => {
      const normalized = normalize(response.data, [categoryEntity]);
      const { categories, subcategories} = normalized.entities;

      dispatch(setIds(normalized.result))
      dispatch(setCategories({ ...categories, ...subcategories }))
    })
    .catch(response => dispatch(setError(response.data.errors)));
}
